﻿import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederBarnestipendDto from '../Models/VeilederBarnestipendDto';

const toForeldre = 'b1-toForeldre';
const alene = 'b2-alene';

const bValg: RadioButtonValgModel<VeilederBarnestipendDto>[] = [
    {
        id: 'b1',
        value: toForeldre,
        tekst: 'familiesituasjonValgB1ToForeldre',
    },
    {
        id: 'b2',
        value: alene,
        tekst: 'familiesituasjonValgB2AleneForeldre',
    },
];

export default {
    b1ToForeldre: toForeldre,
    b2Alene: alene,
    bValg,
};
